module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/bluecoders.png')
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "inline"
  }, [_vm._v("User Group | Developer Community")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.about))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.more))]), _vm._v(" "), _c('v-divider'), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "inline"
  }, [_vm._v("Our Mission")]), _vm._v(" "), _vm._m(0), _c('p', [_c('v-divider')], 1), _c('h3', {
    staticClass: "inline"
  }, [_vm._v("Topics")]), _vm._v(" "), _c('topics')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('ul', [_c('li', [_vm._v("DEVELOPERS with a passion to EXPLORE, CODE & SHARE.")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("our MISSION is to enable DEVELOPERS on latest & hottest  technologies around CLOUD & AI.")]), _c('br'), _vm._v(" "), _c('li', [_vm._v("We SPEAK any PROGRAMMING LANGUAGE.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd63a498","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 833
// module chunks = 1